<template>
  <popup teleport="body" v-model:show="show" style="border-radius: 8px">
    <div class="guide-pop">
      <div class="adv-pic-box">
        <h1>{{ $t('APP_HOME.F_GE_SL_WHTS8XBH_NP_A5S0K') }}</h1>
        <h2>{{ $t('APP_HOME.LY_L_SH9I_ATY8RE_YG_QN_YLA_Z') }}</h2>
        <div class="adv-pic">
          <img
            alt="guide"
            src="https://static.service.z-trip.cn/resources/pic/1294525497655-e22d1bce-a839-473b-a4a6-0d89a39ecc47.png"
          />
        </div>
        <div class="adv-btn">
          <button @click="showGuide('bind')">
            {{ $t('APP_HOME.OIF1_OFJC_VU_REO_G61_D_ZT8_Q')
            }}<img
              src="https://static.service.z-trip.cn/resources/pic/1255373615849-b7db73ba-fdb0-4a2f-983a-6566a716614d.svg"
              alt=""
              style="width: 18px; height: 18px; display: inline-block"
            />
          </button>
          <a @click="showGuide('cancle')">{{ $t('APP_HOME.K_F_YA_LJ_BF_OG_U9P_KE_OJ_RP_L') }}</a>
        </div>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from 'vant/es/popup'
export default {
  name: 'GuidePop',
  components: {
    Popup
  },
  props: {
    show: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  methods: {
    showGuide(type) {
      this.$emit('bindBtn', type)
    }
  }
}
</script>
<style lang="scss" scope>
.guide-pop {
  .adv-pic-box {
    width: 280px;
    height: 380px;
    background: linear-gradient(180deg, #ffecd6 0%, rgba(255, 255, 255, 0) 100%);
    padding: 0 16px;
    border-radius: 8px;
    h1 {
      padding-top: 24px;
      font-weight: 600;
      color: #ff6c10;
      font-size: 22px;
      text-align: center;
    }
    h2 {
      color: #666;
      font-weight: normal;
      font-size: 18px;
      text-align: center;
    }
    .adv-pic {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 28px;
      padding: 0 5%;
      img {
        display: block;
        flex: 1;
      }
    }
    .adv-btn {
      margin-top: 40px;
      button {
        width: 100%;
        background: linear-gradient(90deg, #ff6c10 0%, #feaa43 100%);
        border-radius: 4px;
        border: none;
        color: #fff;
        height: 40px;
        font-size: 16px;
        font-weight: 600;
      }
      a {
        display: block;
        margin-top: 16px;
        width: 100%;
        font-size: 12px;
        color: #999;
        text-align: center;
      }
    }
  }
}
</style>
